import { Component, Inject, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { SubjectRelay } from 'src/main/angular/app/shared/commands/subject-relay.class';
import { AccesService } from '../services/acces.service';
import { OuvrageAccesDTO } from '../entities/ouvrage-acces-dto.entity';
import { etatOuvrageColors } from '../../../../app.constants';

type EtatOuvrage = {
	ouvrage: string;
	color: string | undefined;
}

@Component({
	selector: 'etat-ouvrage',
	templateUrl: 'etat-ouvrage.html',
	styleUrls: ['etat-ouvrage.css']
})
export class EtatOuvrageComponent {
	
	readonly etatOuvrageColors = etatOuvrageColors;
	etatOuvrages: EtatOuvrage[] = [];

	acces$ = new BehaviorSubject<number>(-1);
	
	constructor(@Inject(AccesService) accesService: AccesService) {
		
		// lors de la reception d'une demande d'affichage
		this.acces$.pipe(
			// Recuperation de l'acces
			filter(accesId => accesId !== -1), // ignorer l'init value
			mergeMap(
				(accesId: number) => accesService.getOuvrageDTOByAcces(accesId)
			)
		).subscribe(
			(ouvragesEtats: OuvrageAccesDTO[]) => {
				this.etatOuvrages = [];
				let eos: EtatOuvrage[] = ouvragesEtats.map(
					(ouvrageEtat) => ({
						ouvrage: ouvrageEtat.nom,
						color: this.etatOuvrageColors[ouvrageEtat.etatAcces]
					} as EtatOuvrage)
				);
				this.etatOuvrages = eos;
			}
		);
	}
	
	@Input() set accesId(acccesId: number) {
		if (acccesId) {
			this.acces$.next(acccesId);
		}
	}

	@Input() ouvrageNoms: string = '';

}